import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { getAppShortlink } from 'marketplace-ui-assets-core/utils/urls';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import getDataFetchingClientStatus from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientErrorStatus';
import ThemeDetailsResponse from 'marketplace-ui-assets-core/details/records/ThemeDetailsResponse';
import { GET_THEME_DETAILS_PREVIEW } from '../queries/themeDetailsPreviewQuery';
import NotFoundError from '../../components/error/NotFoundError';
import GenericError from '../../components/error/GenericError';
import StorefrontUsageTrackerProvider from '../../context/StorefrontUsageTrackerProvider';
import ThemeDetailsPage from '../components/ThemeDetailsPage';
export default function ThemeDetailsPreviewContainer() {
  const {
    slug
  } = useParams();
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_THEME_DETAILS_PREVIEW, {
    variables: {
      slug
    }
  });
  const themeDetails = useMemo(() => {
    const detailsPreviewData = data || previousData;

    if (!detailsPreviewData) {
      return new ThemeDetailsResponse();
    } else {
      return new ThemeDetailsResponse(detailsPreviewData.detailsPreview);
    }
  }, [data, previousData]);
  const requestState = getDataFetchingClientRequestState(error, loading);

  if (error) {
    switch (getDataFetchingClientStatus(error)) {
      case 403:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "THEME_DETAILS_FORBIDDEN_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(UIErrorMessage, {
              illustration: "keys",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.themes.details.previewForbiddenError.title"
              }),
              children: /*#__PURE__*/_jsx(UIButton, {
                className: "m-top-4",
                href: getAppShortlink({
                  pathname: `/website/themes/_preview/${slug}`
                }, false),
                use: "tertiary",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.themes.details.previewForbiddenError.buttonText"
                })
              })
            })
          });
        }

      case 404:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "THEME_DETAILS_404_LOAD",
            children: /*#__PURE__*/_jsx(NotFoundError, {})
          });
        }

      default:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "THEME_DETAILS_ERROR_LOAD",
            children: /*#__PURE__*/_jsx(GenericError, {})
          });
        }
    }
  }

  if (requestState !== 'SUCCEEDED') {
    return null;
  }

  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerProvider, {
    children: [/*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.title"
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.previewAlert.message"
      })
    }), /*#__PURE__*/_jsx(ThemeDetailsPage, {
      themeDetails: themeDetails,
      use: "preview"
    })]
  });
}